import { createContext } from 'react';
import { INIT_LOADING_STATE } from './reducer';

export const LoadingMapContext = createContext({
  loadingByComponent: INIT_LOADING_STATE,
  reducerDispatch: () => {},
});
